import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { FeatureNotAvailableDialog, ReadMoreDialog, FeatureNotAvailable2BDialog, ImageCropperDialog, CropperType } from './utility.component';


@Injectable({
	providedIn: 'root'
})
export class UtilityService {
	constructor(
		private dialog: MatDialog
	) { }

	openNewFeatureDialog() {
		this.dialog.open(
			FeatureNotAvailableDialog,
			{
				maxWidth: '850px',
				disableClose: false,
				autoFocus: true,
				panelClass: 'jmDialog'
			}
		);
	}

	openReadMoreDialog(title: string, desc: string, url: string) {
		this.dialog.open(
			ReadMoreDialog,
			{
				maxWidth: '500px',
				disableClose: false,
				autoFocus: true,
				panelClass: 'jmDialog',
				data: {
					'title': title.trim(),
					'description': desc.trim(),
					'objectURL': url.trim()
				}
			}
		);
	}

	openNewFeatureDialog2B(img: string) {
		img = img ?? "assets/images/connections-followers-favorites-lg.png";
		this.dialog.open(
			FeatureNotAvailable2BDialog,
			{
				maxWidth: '850px',
				width:'95%',
				disableClose: false,
				autoFocus: true,
				panelClass: 'jmDialog',
				data: {
					'img': img
				}
			}
		);
	}

	openImageCropper(imgType: CropperType, img: string): Rx.Observable<any> {
		let maxWidth: string = AppSettingService.widgetMobile() ? "99%" : "850px";
		let popup = this.dialog.open(
			ImageCropperDialog,
			{
				disableClose: true,
				maxWidth: maxWidth,
				panelClass: 'jmDialogNoScroll',
				data: {
					imgType: imgType,
					selectedImage: img
				}
			}
		);
		return popup.afterClosed();
	}
}



@Injectable({
	providedIn: 'root'
})
export class ValidateDateService {
	minMonth = 1;
	maxMonth = 12;
	minDay = 1;
	maxDay = 31;
	minYear = 1900;
	maxYear = 1900;
	private dateError = '';

	constructor() {
		this.maxYear = parseInt(moment().format('YYYY'));
	}

	get DateError(): string {
		return this.dateError;
	}
	set DateError(msg: string) {
		this.dateError = msg;
	}

	validateMonth(month: any): any {
		if (typeof month !== 'undefined' && month.length > 0) {
			if (this.validateFormat(this.minMonth, this.maxMonth, month) === false) {
				this.DateError = 'Month format is MM (01-12)';
				return false;
			}
			return true;
		}
		else {
			this.DateError = 'Month is empty';
			return false;
		}
	}

	validateDay(day: any): any {
		if (typeof day !== 'undefined' && day.length > 0) {
			if (this.validateFormat(this.minDay, this.maxDay, day) === false) {
				this.DateError = 'Day format is DD (01-31)';
				return false;
			}
			return true;
		}
		else {
			this.DateError = 'Day is empty';
			return false;
		}
	}

	validateYear(year: any): any {
		if (typeof year !== 'undefined' && year.length > 0) {
			if (this.validateFormat(this.minYear, this.maxYear, year) === false) {
				//console.log('year format');
				this.DateError = 'Year format is YYYY (1900-' + this.maxYear + ')';
				return false;
			}
			return true;
		}
		else {
			this.DateError = 'Year is empty';
			return false;
		}
	}

	validateDateString(date: any): any {
		return moment(date).isValid();
	}

	createDateString(month: any, day: any, year: any): any {
		return moment(year + '-' + month + '-' + day).format('YYYY-MM-DD');
	}

	validateDate(month: any, day: any, year: any): any {
		if (this.validateMonth(month) && this.validateDay(day) && this.validateYear(year)) {
			var date = this.createDateString(month, day, year);
			return moment(date).isValid();
		}
		return false;
	}

	validateFormat(min: any, max: any, val: any): any {
		var tempFormat = '';
		for (var i = min; i <= max; i++) {
			tempFormat = i;
			if (i / 10 < 1) {
				tempFormat = '0' + i.toString();
			}
			else {
				tempFormat = i.toString();
			}
			if (tempFormat === val) {
				return true;
			}
		}
		return false;
	}
}

@Injectable({
	providedIn: 'root'
})
export class DOBService {
	constructor(private vDate: ValidateDateService) {
	}

	private _month: string;
	private _day: string;
	private _year: string;
	private _dob: string = "";
	private _age?: number = null;
	private _minAge: number = 13;
	private _dateError: string = "";

	set Month(v: string) { this._month = v; }
	get Month(): string { return this._month; }

	set Day(day: string) { this._day = day; }
	get Day(): string { return this._day; }

	set Year(year: string) { this._year = year; }
	get Year(): string { return this._year; }

	set Dob(dob: string) { this._dob = dob; };
	get Dob(): string { return this._dob; }

	set Age(age: number) { this._age = age; }
	get Age(): number { return this._age; };

	validate(format: string, val: string): any {
		let res = { 'result': false, 'dateresult': false };
		if (format === 'month') {
			if (this.vDate.validateMonth(val) === true) {
				this.Month = val;
				res.result = true;
			}
			else {
				this.Month = "";
			}
		}
		else if (format === 'day') {
			//console.log(attrs.nextElement);
			if (this.vDate.validateDay(val) === true) {
				this.Day = val;
				res.result = true;
			}
			else {
				this.Day = "";
			}
		}
		else if (format === 'year') {
			//console.log(attrs.nextElement);
			if (this.vDate.validateYear(val) === true) {
				this.Year = val;
				res.result = true;
			}
			else {
				this.Year = "";
			}
		}

		//when all the values are set, validate date
		if (format === 'year' && this._year.length > 0 && this.vDate.validateDate(this._month, this._day, this._year) === true) {
			res.dateresult = true;
			this.Dob = this.vDate.createDateString(this._month, this._day, this._year);
			this.Age = moment().diff(this.Dob, 'y', true);
		}
		else {
			this._dateError = this.vDate.DateError;
		}

		return res;
	}

	getDateError(): any {
		return this._dateError;
	}

	validateDate(month: string, day: string, year: string): any {
		//console.log('validateDate');
		var res = this.validate('month', month);
		if (res.result === true) {
			res = this.validate('day', day);
			if (res.result === true) {
				res = this.validate('year', year);
			}
		}
		return res.dateresult;
	}

	validateAge(): boolean {
		if (this._age != null) {
			if (this._age >= this._minAge) {
				return true;
			}
			else {
				return false;
			}
		}
		else {
			return null;
		}
	}
}
